import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import isEmail from 'validator/es/lib/isEmail';
import type { VoidFunctionComponent } from 'react';

import { window } from '../../../globals';
import { BUTTON_SIZE, BUTTON_TYPE, ButtonGroup, LoaderButton } from '../../generic';
import Button from '../../generic/Button';
import LabeledMultiTextInput from '../../generic/Forms/LabeledMultiTextInput';

import styles from './EmailReportDialog.module.less';

const defaultEmails: string[] = window.user?.email ? [window.user.email] : [];

type Props = {
  onClose: () => void;
  onConfirm: (emails: string) => void;
  isLoading: boolean;
};

/**
 * Dialog for entering email addresses to send a V3 report to.
 */
const EmailReportDialog: VoidFunctionComponent<Props> = ({
  onClose,
  onConfirm,
  isLoading,
}) => {
  const [emails, setEmails] = useState<string[]>(defaultEmails);
  const areEmailsValid = emails.length > 0 && emails.every((email) => isEmail(email.trim()));

  return (
    <Modal onHide={onClose} className="modal-confirm" show>
      <Modal.Header closeButton>
        <Modal.Title>Email Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LabeledMultiTextInput
          id="email-report-addresses"
          size="small"
          label="Email Address(es)"
          placeholder="Enter an email address"
          values={emails}
          onChange={setEmails}
        />
        {emails.length > 0 && !areEmailsValid && (
          <div className={styles.error}>
            Please enter valid email addresses
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button type="secondary" size={BUTTON_SIZE.MEDIUM} onClick={onClose}>
            Cancel
          </Button>
          <LoaderButton
            isLoading={isLoading}
            isDisabled={!areEmailsValid}
            type={BUTTON_TYPE.PRIMARY}
            size={BUTTON_SIZE.MEDIUM}
            onClick={() => onConfirm(emails.join(','))}
          >
            Email
          </LoaderButton>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default EmailReportDialog;
